import { NOTIFICATION_ADD, NOTIFICATION_REMOVE } from 'constants/actiontypes';

import { getNewNotifId } from 'reducers/notification';


export const addNotification = (id, data, notifType='primary') => ({
	type: NOTIFICATION_ADD,
  id,
	data,
	notifType,
});

export const removeNotification = (id) => ({
	type: NOTIFICATION_REMOVE,
	id
});

export const showNotificationWithTimeout = (text, notifType='primary') => {
  return (dispatch) => {
    const id = getNewNotifId();
    dispatch(addNotification(id, text, notifType));

    setTimeout(() => {
      dispatch(removeNotification(id))
    }, 3000);
  };
};



/** WEBPACK FOOTER **
 ** ./actioncreators/notification.js
 **/